import _isEmpty from 'lodash/isEmpty';
import _isNumber from 'lodash/isNumber';
import isFinite from 'lodash/isFinite';
import dayjs from 'dayjs'; // eslint-disable-next-line import/prefer-default-export

export function isNumber() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (_isNumber(str)) {
    return true;
  }

  if (_isEmpty(str)) {
    return false;
  }

  if (str.length === 1) {
    return RegExp(/^[0-9.]+$/).test(str);
  }

  return isFinite(+str);
}
export var transformLocale = function transformLocale(locale) {
  if (locale.toLowerCase() === 'zh-cn') {
    return 'zh-cn';
  }

  var normalizedLocale = locale.includes('-') ? locale.toLowerCase().split('-')[0] : locale.toLowerCase().slice(0, 2);
  return normalizedLocale || 'en';
};
export var dateToFromNow = function dateToFromNow(targetDate, isEnglish) {
  if (isEnglish) {
    var now = dayjs();
    var diffInDays = now.diff(targetDate, 'days');

    if (Math.abs(diffInDays) !== 1) {
      return targetDate.fromNow();
    }

    return diffInDays > 0 ? 'Yesterday' : 'Tomorrow';
  }

  return targetDate.fromNow();
};